import { keepPreviousData, useQuery } from "@tanstack/react-query";
import {
  getMarketingDiecuts,
  getMarketingDiecutsPage,
  getMarketingDiecutBySlug,
  getMarketingRelatedDiecuts,
  type MarketingDiecutsPageParams,
} from "@/src/actions/marketing-diecuts";
import { getDiecutCategorySummary, getDiecutKnifeData } from "@/src/actions/diecuts";

export function useMarketingDiecuts() {
  return useQuery({
    queryKey: ["marketing-diecuts"],
    queryFn: () => getMarketingDiecuts(),
  });
}

export function useMarketingDiecutsPage(params: MarketingDiecutsPageParams) {
  return useQuery({
    queryKey: ["marketing-diecuts-page", params],
    queryFn: () => getMarketingDiecutsPage(params),
    placeholderData: keepPreviousData,
  });
}

export function useMarketingDiecutCategories() {
  return useQuery({
    queryKey: ["marketing-diecut-categories"],
    queryFn: () => getDiecutCategorySummary(),
  });
}

export function useMarketingDiecutDetail(slug: string | undefined) {
  return useQuery({
    queryKey: ["marketing-diecut", slug],
    queryFn: () => getMarketingDiecutBySlug(slug!),
    enabled: !!slug,
  });
}

export function useRelatedDiecuts(
  categoryId: number | undefined,
  excludeSlug: string | undefined,
) {
  return useQuery({
    queryKey: ["marketing-related-diecuts", categoryId, excludeSlug],
    queryFn: () => getMarketingRelatedDiecuts(categoryId!, excludeSlug!),
    enabled: !!categoryId && !!excludeSlug,
  });
}

export function useMarketingDiecutKnifeData(slug: string | undefined) {
  return useQuery({
    queryKey: ["marketing-diecut-knife", slug],
    queryFn: () => getDiecutKnifeData(slug!),
    enabled: !!slug,
  });
}
